"use client";

import React, { useEffect, useRef, useState } from "react";
import "@/styles/reveal.css";

type ScrollRevealProps = {
	children: React.ReactNode;
	className?: string;
	delay?: number;
	id?: string;
};

export function ScrollReveal({ children, className = "", delay = 0, id }: ScrollRevealProps) {
	const ref = useRef<HTMLDivElement>(null);
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		const el = ref.current;
		if (!el) return;

		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) {
					setVisible(true);
					observer.disconnect();
				}
			},
			{ threshold: 0.15, rootMargin: "0px 0px -60px 0px" },
		);

		observer.observe(el);
		return () => observer.disconnect();
	}, []);

	return (
		<div
			ref={ref}
			id={id}
			className={`reveal ${visible ? "reveal-visible" : ""} ${className}`}
			style={{ transitionDelay: visible ? `${delay}ms` : "0ms" }}
		>
			{children}
		</div>
	);
}
